module.exports = __webpack_public_path__ + "static/banner-e10fb44f3a7642c62347d81418e8b43a.jpg";